<template>
    <div id="modal-container-offsite" class="modal" tabindex="-1" role="dialog" aria-labelledby="modal-container-offsite" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content rounded-0">
                <div class="modal-header rounded-0">
                    <h4 class="modal-title">External Page Access</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <iframe :src="offsiteUrl">

                    </iframe>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-dark" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        name: 'OffsiteModal',
        computed: {
            ...mapState({
                offsiteUrl: state => state.navigation.offsiteUrl,
            })
        }
    }
</script>

<style scoped>

    .modal-body {
    }

    .modal-dialog {
        width: calc(100vw - 34px);
        max-width: calc(100vw - 34px) !important;
    }

    .modal-body iframe {
        width: calc(100vw - 34px);
        height: calc(100vh - 250px);
        border: 0px;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
        position: relative;
    }

    .modal-container {
        width: 100vw;
        margin: 0px auto;
        padding: 10px 15px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    div.login-modal-container {
        padding: 0px;
        position: relative;
        box-shadow: 2px 2px 10px;
    }

    .login-panel {
        padding-left: 0;
        padding-right: 0;
        float: none;
        margin: auto;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 10px 0;
        padding: 0rem 1rem;
    }

    .modal-default-button {
        display: block;
        margin-top: 1rem;
    }
</style>